import { render, staticRenderFns } from "./ServicesBarChart.vue?vue&type=template&id=7b417df3"
import script from "./ServicesBarChart.vue?vue&type=script&lang=js"
export * from "./ServicesBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b417df3')) {
      api.createRecord('7b417df3', component.options)
    } else {
      api.reload('7b417df3', component.options)
    }
    module.hot.accept("./ServicesBarChart.vue?vue&type=template&id=7b417df3", function () {
      api.rerender('7b417df3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Dashboard/Stats/ServicesBarChart.vue"
export default component.exports